// extracted by mini-css-extract-plugin
export default {"ExternalLink":"_ExternalLink--_u7Es","ExternalLinkBody":"_ExternalLinkBody--ylAS1"};